import resume from '../assets/pdf/resume.pdf'
import prf from '../assets/profile/profilepic.png'

export const headerData = {
    name: 'Ahan Bandyopadhyay',
    title: "Full Stack Web Developer",
    desciption: "Software development is more than just writing code; it's a journey of continuous learning, problem-solving, and creativity. Like architects designing blueprints, developers craft intricate solutions that shape the digital world, each line of code a brushstroke on the canvas of innovation.",
    image: prf,
    resumePdf: resume
}
